import React from 'react'
import DesignerList from './DesignerList'
import DesignerProfile from './DesignerProfile'
import { superAdmin } from '../../lib/constants'

const RerouteIHUser = () => {
    const userpermissions = JSON.parse(localStorage.getItem("permissions"))
    const isAdmin = (userpermissions.includes(superAdmin))
     
  return (
    isAdmin ? <DesignerList/> : <DesignerProfile/>
  )
}

export default RerouteIHUser